<template>

  <!-- transition="dialog-bottom-transition" -->
  <v-dialog
  v-model="localDialog"
  fullscreen
  transition="fade-transition"
  >

    <div class="dialog-main-container">

      <div ref="cardContainer" class="card-container pt-0 pb-0 pr-2">

        <transition appear v-on:before-enter="beforeEnter" v-on:enter="expand" v-on:leave="collapse" v-bind:css="false">
          <div v-if="localDialog" class="">
            <v-card :class="['opaque-background pa-3 dialog-card', {'full-width': fullWidth}]">
              <v-card-text>
                <slot name="content"></slot>
              </v-card-text>
              <v-card-actions>
                <v-btn 
                icon
                flat
                class="mr-3 mt-3"
                @click="localDialog=false">
                  <v-icon large color="blue">close</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </transition>

      </div>

    </div>

  </v-dialog>
</template>

<script>
import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui.min.js'

export default {
  props: {
    dialog: false,
    fullWidth: false
  },
  data () {
    return {
    }
  },
  computed: {
    localDialog: {
      get () {
        return this.dialog
      },
      set (nv) {
        this.$emit('update:dialog', nv)
      }
    }
  },
  watch: {
    dialog (nv) {
      // scroll dialog to top on reopen
      if (nv) {
        this.$nextTick(() => {
          this.$refs.cardContainer.scrollTop = 0
        })
      }
    }
  },
  methods: {
    // ANIMATION
    beforeEnter: function (el) {
      // el.style.opacity = 0
      // this.$refs.cardContainer.style.overflow = 'hidden'
      this.$refs.cardContainer.style.transform = 'scale(0, 0)'
      Velocity(this.$refs.cardContainer, { scale: 0.8, opacity: 0.5 }, { duration: 0 })
    },
    expand: function (el, done) {
      Velocity(el, 'slideDown', { duration: 500 })
      Velocity(this.$refs.cardContainer, { scale: 1, opacity: 1 }, { duration: 300 })
      Velocity(this.$refs.cardContainer, { opacity: 1 }, { complete: done })
        .then(() => {
          this.$refs.cardContainer.style.overflow = 'auto'
        })
      // $('img').velocity( 'transition.flipYIn' );
    },
    collapse: function (el, done) {
      Velocity(el, 'slideUp', { duration: 500 })
      // Velocity(el, { opacity: 1 }, { complete: done })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-main-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.card-container {
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  margin: auto;
  max-height: 95%;
}

.dialog-card {
  margin: auto;
  overflow: auto;
  box-shadow: none;
  border: none;
  border-radius: 4px;
}

.full-width {
  width: 100%;
}

.theme--light {
    & .card-container {
      /* Scroll bar */
      /* width */
      &::-webkit-scrollbar {
        width: 10px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: rgba(255,255,255,0.1);
        background: none;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: rgba(255,255,255,0.5);
        border-radius: 20px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: rgba(255,255,255,0.6); 
      }

      &::-webkit-scrollbar-corner {
        background: transparent;
      }
    }
}
</style>
